function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eaf00474-fcec-45ff-9348-0cb3e74360ce",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "e7ebded3-c11d-4bb5-a4e7-22c8f0be8a0c",
    "data-name": "Wave-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e6769836-ab16-41c5-8c0a-4559b8bc30aa",
    "data-name": "Rectangle",
    d: "M0,0C651,0,715,47.0505,1366,47.0505V48H0Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave3;